
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nettbutikk",
      function () {
        return require("private-next-pages/nettbutikk/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/nettbutikk"])
      });
    }
  